import { useNavigate } from 'react-router-dom';
import useEnrollmentStore from "../../store/EnrollmentStore";
import { Box, Button, Typography } from '@mui/material';
import { paths } from '../../paths';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AppProgressBar from "../../Common/progressBar";
import TaxPreparationServiceFormContext from "./TaxPreparationServiceFormContext";
import { useContext } from "react";
import Footer from '../footer';

export const EnrollCompletedPageV2 = () => {
  const { setTaxPrepEnrollment ,protectionPlanEnrollment} = useEnrollmentStore();
  const navigate = useNavigate();

    const continueHandler = () => {
      setTaxPrepEnrollment({
        taxPrepEnrollmentCompleted: true,
        showTaxPrepNextStepsModal: true,
        paymentCompleted: true
      });
      if (!protectionPlanEnrollment || protectionPlanEnrollment?.subscriptionPlan == "") {
        navigate("/dashboard/tax-shield/enrollment")
      }else{
      navigate(paths.dashboard.taxShield.reports);
      }
    }
    
    return (
        <>
          <div className="page-container">
        <Box sx={{alignItems: 'flex-center',
            p: { xs: 2, md: 6, lg: 4 },
            m: { xs: 2, md: 6, lg: 4 }}}>
            <Box sx={{
              alignItems: 'flex-center',
              pl: { xs: 2, md: 6, lg: 4 },
              pr: { xs: 2, md: 6, lg: 4 }
            }}>
                <Typography variant="h5" sx={{mb: 2}}>{'We are preparing your tax return'}</Typography>
                <Typography variant="body2" sx={{mb: 2}}>{'You’re now enrolled in the Optima Tax Shield. Head over to your dashboard to check out your plan and other tax tools like our IRS Notice Analyzer.'}</Typography>
                <Button
                    onClick={continueHandler}
                    className="option-primary-button"
                >
                    Continue to Dashboard
                </Button>
            </Box>    
        </Box>
        </div>
        <Footer/>
      </>
    )
}

export const EnrollCompletedPage = () => {
  const {taxPreparationData, setTaxPreparationData, navigateToPage  } = useContext(TaxPreparationServiceFormContext);
  const { setTaxPrepEnrollment } = useEnrollmentStore();
  const navigate = useNavigate();

  const continueHandler = () => {
    setTaxPrepEnrollment({
      taxPrepEnrollmentCompleted: true,
      showTaxPrepNextStepsModal: true,
      paymentCompleted: true
    });
    navigate('/dashboard');
  }

  return (
    <>
      <Container className="mt-3 mb-5">
        <Row className="row justify-content-center">
          <Col md={10} className="content-box pt-5 pb-5 px-lg-5">
            <div className="mx-lg-5">
              <AppProgressBar progressPercent={100} />
              <Row className="justify-content-center">
                <Col md={12}>
                  <h1 className="content-box-heading mb-4">
                    {'Thank You For Your Payment.'}
                  </h1>
                  <p className="content-text" style={{fontSize: '13px'}}>
                    {'Your case will now be assigned to a tax professional to review the details you provided and be in touch within 48 hours with a preliminary list of items they will need.'}</p>
                  <p className="content-text" style={{fontSize: '13px'}}>
                    {'In the meantime, please organize your tax documents so you have a head start.'}</p>
                  <Row className="justify-content-start my-4">

                    <div className="d-flex justify-content-end mt-3 align-items-center">
                      <button
                        className={"btn-continue fw-bold"}
                        style={{padding: '25px 10px', fontSize: '14px', textAlign: 'center', lineHeight: '0px'}}
                        onClick={continueHandler}>
                        Finish
                      </button>
                    </div>
                  </Row>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}